<cm-add-item-dialog [title]="'New ' + $templateTypeName()" [confirmDisabled]="!$validatedInputData()" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <ng-container cm-dialog-content>
        <div class="cm-add-template-name">
            <cm-input-container>
                <ng-container cm-inline-label> Name:</ng-container>
                <ng-container cm-input>
                    <cm-string-input [value]="$data().name" (valueChange)="updateData({name: $event})"></cm-string-input>
                </ng-container>
            </cm-input-container>
        </div>

        @if ($can().read.menu("extendedCreate")) {
            <cm-organization-select
                class="cm-add-template-organization"
                [updateOrganization]="updateOrganization.bind(this)"
                [organizationId]="$data().organizationId ?? null"
                [showIfViewedByOwner]="false"
                [showLabel]="false"
                [usedInAddEntityContext]="true"
            ></cm-organization-select>
        }

        @if ($can().update.template(null, "type") && $sortedTemplateTypeLabels().length > 1) {
            <mat-form-field class="cm-add-template-type" appearance="outline">
                <mat-select
                    [value]="$data().templateType"
                    (valueChange)="updateData({templateType: $event})"
                    placeholder="Type"
                    name="templateType"
                    [disabled]="!$can().update.template(null, 'type')"
                >
                    @for (templateType of $sortedTemplateTypeLabels(); track templateType.state) {
                        <mat-option [value]="templateType.state">{{ templateType.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <div class="cm-add-template-details">
            @for (method of $createMethods(); track method) {
                <button
                    class="cm-text-button cm-left-panel-option"
                    (click)="updateData({createMethod: method.id})"
                    [class.cm-selected]="$data().createMethod === method.id"
                >
                    <i [class]="'far ' + method.icon"></i>
                    {{ method.label }}
                </button>
            }
        </div>

        <div class="cm-add-template-info">
            @switch ($data().createMethod) {
                @case ("BLANK") {
                    <cm-hint>
                        <ng-container cm-text> Create {{ $currentTemplateTypeName() }} from <b>scratch</b>.</ng-container>
                    </cm-hint>
                }
                @case ("FROM_FBX_OBJ_PLY") {
                    <cm-hint>
                        <ng-container cm-text> Create {{ $currentTemplateTypeName() }} by uploading <b>FBX, OBJ or PLY file</b>.</ng-container>
                    </cm-hint>
                    <cm-drop-files
                        [enableDrop]="true"
                        [maxFiles]="1"
                        [accept]="Accept.Meshes"
                        [showDropzone]="!$data().meshFile?.file"
                        [subtitle]="'Click to browse for files.'"
                        (filesDropped)="updateMeshFile({file: $event[0]})"
                    >
                        <div class="cm-file-thumbnail">
                            <div class="cm-file-icon-container">
                                <i class="cm-file-icon far fa-file"></i>
                                <p>{{ $data().meshFile?.file?.name }}</p>
                            </div>
                            <button class="cm-file-thumbnail-button cm-button cm-remove" (click)="updateMeshFile({file: undefined})">
                                <i class="far fa-trash"></i>
                            </button>
                        </div>
                    </cm-drop-files>
                    @if ($meshError()) {
                        <div class="cm-mesh-error">
                            <i class="far fa-exclamation-triangle"></i>
                            {{ $meshError() }}
                        </div>
                    }

                    <cm-checkbox [value]="$data().centerOrigin" (valueChange)="$data.set({...$data(), centerOrigin: $event})">
                        <ng-container> Center Origin </ng-container>
                    </cm-checkbox>
                    <cm-checkbox [value]="$data().consolidate" (valueChange)="$data.set({...$data(), consolidate: $event})">
                        <ng-container> Weld Vertices </ng-container>
                    </cm-checkbox>
                    <cm-checkbox [value]="$data().convertToWorldSpaceUvs" (valueChange)="$data.set({...$data(), convertToWorldSpaceUvs: $event})">
                        <ng-container cm-label> Convert to World Space UVs </ng-container>
                    </cm-checkbox>
                    <div>
                        <legend>Scale:</legend>
                        <cm-radio-group [value]="$scaleFactorSelection()" (valueChange)="updateScaleFactor($event)" #scaleGroup="cmRadioGroup">
                            <div class="cm-radio-buttons">
                                <cm-radio-button [value]="DefaultScaleOptions.mm">
                                    <ng-container>mm</ng-container>
                                </cm-radio-button>
                                <cm-radio-button [value]="DefaultScaleOptions.cm">
                                    <ng-container>cm</ng-container>
                                </cm-radio-button>
                                <cm-radio-button [value]="DefaultScaleOptions.m">
                                    <ng-container>m</ng-container>
                                </cm-radio-button>
                                <cm-radio-button [value]="DefaultScaleOptions.custom" #customOpt="cmRadioButton">
                                    <ng-container>
                                        <cm-input-container>
                                            <ng-container cm-inline-label> Custom:</ng-container>
                                            <ng-container cm-input>
                                                <cm-numeric-input
                                                    [value]="$data().scaleFactor"
                                                    (valueChange)="$data.set({...$data(), scaleFactor: $event!})"
                                                    [disabled]="!customOpt.$checked()"
                                                    [decimalPlaces]="2"
                                                    placeholder="Custom scale factor"
                                                />
                                            </ng-container>
                                        </cm-input-container>
                                    </ng-container>
                                </cm-radio-button>
                            </div>
                        </cm-radio-group>
                    </div>
                    @if ($data().scaleFactor !== 1) {
                        <cm-checkbox [value]="$data().scaleUv0" (valueChange)="$data.set({...$data(), scaleUv0: $event})">
                            <ng-container cm-label> Scale World Space UVs </ng-container>
                        </cm-checkbox>
                    }
                }
                @case ("FROM_GLTF_USDZ") {
                    <cm-hint>
                        <ng-container cm-text> Create {{ $currentTemplateTypeName() }} by uploading a glTF or USDZ file.</ng-container>
                    </cm-hint>
                }
                @default {
                    <span class="cm-add-template-info-text">Select method to create {{ $currentTemplateTypeName() }}.</span>
                }
            }
        </div>
    </ng-container>
</cm-add-item-dialog>
